export const ebay = {
  oAuthFlowHelp: "Ebay autorisieren",
  authSuccess: "Authentifizierung erfolgreich",
  migrationSuccess: "Erfolgreich Token aus eBay übernommen.",
  accountNotice:
    "Bitte stelle sicher, dass du vor der Autorisierung im richtigen eBay-Konto angemeldet bist. Jede Integration benötigt ihr eigenes eBay-Konto – wird ein Konto verwendet, das bereits mit einer anderen Integration verbunden ist, vermischen sich die Daten beider Integrationen. Melde dich vorher bei eBay ab, wenn du nicht weißt, welches Konto aktiv ist."
};
